<template>
  <div id="section4" class="page-section4 section-observer" :class="{ 'is-visible': isVisible }">
    <img src="/img/ornamen_bunga.png" alt="Ornamen" loading="lazy" class="s4-ornamen">
    <img src="/img/ornamen_bunga.png" alt="Ornamen" loading="lazy" class="s4-ornamen-br">
    <img src="/img/Wayang-logo.png" alt="Wayang" loading="lazy" class="s4-wayang fade-on-scroll">

    <img :src="couplePhotoUrl" alt="Couple" loading="lazy" class="s4-couple-photo fade-on-scroll">

    <h2 class="s4-title fade-on-scroll">Countdown Timer</h2>
    <p class="s4-quote fade-on-scroll">"A perfect love is when a couple fall in love for many times and always with the same person."</p>

    <div class="s4-timer fade-on-scroll">
      <div class="timer-box">
        <span class="timer-num">{{ timer.days }}</span>
        <span class="timer-label">Hari</span>
      </div>
      <div class="timer-sep">:</div>
      <div class="timer-box">
        <span class="timer-num">{{ timer.hours }}</span>
        <span class="timer-label">Jam</span>
      </div>
      <div class="timer-sep">:</div>
      <div class="timer-box">
        <span class="timer-num">{{ timer.minutes }}</span>
        <span class="timer-label">Menit</span>
      </div>
      <div class="timer-sep">:</div>
      <div class="timer-box">
        <span class="timer-num">{{ timer.seconds }}</span>
        <span class="timer-label">Detik</span>
      </div>
    </div>

    <button class="btn-save-date fade-on-scroll">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
      Save The Date
    </button>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';

export default {
  name: 'CountdownSection',
  data() {
    return {
      isVisible: false,
      timer: { days: '00', hours: '00', minutes: '00', seconds: '00' },
      interval: null,
    };
  },
  computed: {
    ...mapState(useInvitationStore, ['client', 'config', 'randomGalleryPicks']),
    couplePhotoUrl() {
      const pick = this.randomGalleryPicks?.[0];
      if (pick) return `https://admin.itsyourdayofficial.com/gallery/${encodeURIComponent(pick)}`;
      const foto = this.client.foto_couple || this.client.foto_cover;
      return foto
        ? `https://admin.itsyourdayofficial.com/foto_cover/${foto}`
        : 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&q=80';
    },
    targetDate() {
      if (this.config.countdown === 'akad') return this.client.tgl_akad;
      return this.client.tgl_resepsi || this.client.tgl_akad;
    },
  },
  mounted() {
    this.startCountdown();
    this.setupObserver();
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this.interval) clearInterval(this.interval);
    if (this._sectionObserver) this._sectionObserver.disconnect();
    if (this._fadeObserver) this._fadeObserver.disconnect();
  },
  methods: {
    pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    },
    startCountdown() {
      const tick = () => {
        if (!this.targetDate) return;
        const diff = new Date(this.targetDate) - new Date();
        if (diff <= 0) {
          this.timer = { days: '00', hours: '00', minutes: '00', seconds: '00' };
          return;
        }
        this.timer = {
          days: this.pad(Math.floor(diff / 86400000)),
          hours: this.pad(Math.floor((diff % 86400000) / 3600000)),
          minutes: this.pad(Math.floor((diff % 3600000) / 60000)),
          seconds: this.pad(Math.floor((diff % 60000) / 1000)),
        };
      };
      tick();
      this.interval = setInterval(tick, 1000);
    },
    setupObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      this._sectionObserver = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) this.isVisible = true; },
        { threshold: 0.15 }
      );
      this._sectionObserver.observe(this.$el);
    },
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section4 {
  min-height: 100vh; width: 100%; display: flex; flex-direction: column; align-items: center;
  justify-content: center; background: linear-gradient(160deg, #3B516E 0%, #5A7292 50%, #4A5C74 100%);
  padding: 8rem 2rem; text-align: center; color: #ffffff; position: relative; overflow: hidden;
}
.s4-ornamen {
  position: absolute; top: -30px; left: -50px; width: 200px;
  transform: rotate(-15deg); transform-origin: center center; opacity: 0; pointer-events: none;
}
.s4-ornamen-br {
  position: absolute; bottom: -30px; right: -50px; width: 200px;
  transform: rotate(165deg); transform-origin: center center; opacity: 0; pointer-events: none;
}
.page-section4.is-visible .s4-ornamen {
  animation: slideDown-ornamen 1.5s cubic-bezier(0.2,0.8,0.2,1) forwards, float-ornamen 6s ease-in-out infinite 1.5s;
}
.page-section4.is-visible .s4-ornamen-br {
  animation: slideUp-ornamen 1.5s cubic-bezier(0.2,0.8,0.2,1) forwards, float-ornamen-br 6s ease-in-out infinite 1.5s;
}
@keyframes slideDown-ornamen {
  0%   { opacity: 0; transform: rotate(-15deg) translateY(-100px); }
  100% { opacity: 0.95; transform: rotate(-15deg) translateY(0px); }
}
@keyframes slideUp-ornamen {
  0%   { opacity: 0; transform: rotate(165deg) translateY(-100px); }
  100% { opacity: 0.95; transform: rotate(165deg) translateY(0px); }
}
@keyframes float-ornamen {
  0%, 100% { transform: rotate(-15deg) translateY(0px); }
  50%       { transform: rotate(-15deg) translateY(-14px); }
}
@keyframes float-ornamen-br {
  0%, 100% { transform: rotate(165deg) translateY(0px); }
  50%       { transform: rotate(165deg) translateY(14px); }
}
.s4-wayang { width: 90px; margin-bottom: 1.5rem; filter: brightness(0) invert(1); opacity: 0.9; }
.s4-couple-photo {
  width: 100%; max-width: 320px; height: 250px; object-fit: cover; border-radius: 16px;
  margin-bottom: 2rem; box-shadow: 5px 5px 10px 0px rgba(0,0,0,0.46);
  border: 2px solid white;
}
.s4-title { font-family: 'Tangerine', cursive; font-size: 45px; color: #ffffff; margin-bottom: 1.2rem; text-shadow: 0 2px 12px rgba(0,0,0,0.3); font-weight: 400; }
.s4-quote { font-size: 15px; font-weight: 400; color: #ffffff; line-height: 1.7em; margin-bottom: 2.5rem; text-shadow: 0 1px 6px rgba(0,0,0,0.4); letter-spacing: -0.5px; }
.s4-timer { display: flex; align-items: flex-start; gap: 0.5rem; margin-bottom: 2.5rem; }
.timer-box { display: flex; flex-direction: column; align-items: center; min-width: 60px; }
.timer-num { font-family: 'Cinzel', serif; font-size: 2.8rem; font-weight: 700; color: #ffffff; line-height: 1; text-shadow: 0 4px 15px rgba(0,0,0,0.3); }
.timer-label { font-family: 'Cinzel', serif; font-size: 0.65rem; letter-spacing: 2px; text-transform: uppercase; color: rgba(255,255,255,0.85); margin-top: 0.4rem; }
.timer-sep { font-family: 'Cinzel', serif; font-size: 2.4rem; color: rgba(255,255,255,0.5); line-height: 1; padding-top: 0.1rem; align-self: flex-start; }
.btn-save-date {
  background: #ffffff; border: 1.5px solid #ffffff; color: #4E647A; font-family: 'Cinzel', serif;
  font-size: 14px; letter-spacing: 1.5px; text-transform: uppercase; padding: 0.9rem 2rem;
  border-radius: 30px; display: inline-flex; align-items: center; gap: 8px; cursor: pointer;
  transition: background 0.3s, transform 0.3s; font-weight: 600;
}
.btn-save-date:hover { transform: translateY(-2px); }

@media (max-width: 767px) {
  .page-section4 { padding: 10rem 1.5rem; }
  .s4-ornamen { width: 140px; top: -15px; left: -30px; }
  .s4-ornamen-br { width: 140px; bottom: -15px; right: -30px; }
  .timer-num { font-size: 2.2rem; }
  .timer-sep { font-size: 1.8rem; }
  .timer-label { font-size: 0.55rem; }
}
</style>
